export default __webpack_public_path__ + "static/media/other09.5c9bec64.webp";